export default __webpack_public_path__ + "static/media/home_trusted_logos.3037f7f7.png";